import { render } from "./AppIcon.vue?vue&type=template&id=2e73632a&scoped=true&ts=true"
import script from "./AppIcon.vue?vue&type=script&lang=ts"
export * from "./AppIcon.vue?vue&type=script&lang=ts"

import "./AppIcon.vue?vue&type=style&index=0&id=2e73632a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e73632a"]])

export default __exports__